<div class="auth-page">
  <!-- Navbar do site no estilo da nova home, sem a opção de login (já estamos nela). -->
  <header class="auth-nav">
    <div class="auth-nav-barra">
      <a href="https://www.reachr.com.br" class="auth-nav-logo" title="Reachr">
        <img src="assets/img/reachrlogo.png" alt="Reachr" />
      </a>

      <button
        type="button"
        class="auth-nav-toggle"
        (click)="menuAberto = !menuAberto"
        [attr.aria-expanded]="menuAberto"
        aria-controls="auth-nav-menu"
        aria-label="Abrir menu"
      >
        <span></span><span></span>
      </button>

      <nav id="auth-nav-menu" class="auth-nav-menu" [class.aberto]="menuAberto">
        <ul class="auth-nav-links">
          <li><a href="/">Início</a></li>
          <li><a href="/funcionalidades">Funcionalidades</a></li>
          <li><a href="/planos">Planos</a></li>
          <li><a href="/cases">Cases</a></li>
          <li><a href="/imprensa">Imprensa</a></li>
          <li><a href="/faq">FAQ</a></li>
          <li><a href="https://blog.reachr.com.br">Blog</a></li>
        </ul>
        <a class="auth-nav-cta" href="/para-candidatos">Área do candidato</a>
      </nav>
    </div>
  </header>

  <section class="auth-hero">
    <!-- Painel escuro (some abaixo de 992px). -->
    <aside class="auth-panel" aria-hidden="true">
      <span class="auth-glow auth-glow-1"></span>
      <span class="auth-glow auth-glow-2"></span>
      <span class="auth-glow auth-glow-3"></span>
      <span class="auth-pontos"></span>
      <span class="auth-ondas"><i></i><i></i><i></i></span>

      <div class="auth-panel-conteudo">
        <span class="auth-chip"><span class="auth-chip-ponto"></span>Para empresas</span>
        <h2 class="auth-panel-titulo">Recrutamento com IA, da vaga aberta à contratação.</h2>
        <p class="auth-panel-texto">
          A IA da Reachr analisa cada candidatura e mostra quem combina com a vaga, e por quê.
        </p>

        <ul class="auth-beneficios">
          <li>Publique vagas e receba candidaturas em um só lugar</li>
          <li>A IA destaca quem mais combina com cada vaga</li>
          <li>Acompanhe todo o processo seletivo</li>
        </ul>
      </div>
    </aside>

    <main class="auth-main">
      <div id="fb-root"></div>
      <div class="auth-form">
        <nav class="auth-segmento" aria-label="Tipo de conta">
          <span data-perfil="empresa" class="ativo" aria-current="page">
            <span class="auth-perfil-icone"><i class="fas fa-building" aria-hidden="true"></i></span>
            <span class="auth-perfil-texto"><strong>Sou empresa</strong><small>Quero contratar</small></span>
          </span>
          <a data-perfil="candidato" href="{{ siteUrl }}/paracandidatos/login">
            <span class="auth-perfil-icone"><i class="fas fa-user" aria-hidden="true"></i></span>
            <span class="auth-perfil-texto"><strong>Sou candidato</strong><small>Quero uma vaga</small></span>
          </a>
        </nav>

        <article role="login">
          <h1 class="login-titulo">Bem-vindo de volta</h1>
          <p class="login-subtitulo">Entre na sua conta de empresa para gerenciar suas vagas.</p>

          <app-formulario-login [tipoConta]="'empresa'"></app-formulario-login>
        </article>
      </div>
    </main>
  </section>

  <footer class="auth-site-footer">
    <div class="auth-footer-painel">
      <div class="auth-footer-grid">
        <div class="auth-footer-marca">
          <div class="auth-footer-logos">
            <img src="assets/img/logo-reachr-branco.png" alt="Reachr" class="auth-footer-logo" />
            <img src="assets/img/selo-lgpd.png" alt="Selo LGPD" class="auth-footer-selo" />
          </div>
          <p>Recrutamento com IA, da vaga aberta à contratação.</p>
          <div class="auth-social">
            <a href="https://www.facebook.com/ReachrRecrutamento/" target="_blank" rel="noopener" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
            <a href="https://instagram.com/reachrdigital" target="_blank" rel="noopener" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
            <a href="https://www.linkedin.com/company/reachr-recrutamento/" target="_blank" rel="noopener" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a>
            <a href="https://www.youtube.com/@ReachrContratacaoDigital" target="_blank" rel="noopener" aria-label="YouTube"><i class="fab fa-youtube"></i></a>
          </div>
        </div>

        <div class="auth-footer-coluna">
          <h3>Links úteis</h3>
          <ul>
            <li><a href="/termos-de-uso">Termos de uso</a></li>
            <li><a href="/politica-de-privacidade">Política de privacidade</a></li>
            <li><a href="/faq">Dúvidas frequentes</a></li>
            <li><a href="/protecao-de-dados">Proteção de Dados Contatos do DPO</a></li>
            <li><a href="https://riovagas.com.br" target="_blank" rel="noopener">Parceiro Rio Vagas</a></li>
          </ul>
        </div>

        <div class="auth-footer-coluna">
          <h3>Para empresa</h3>
          <ul>
            <li><a href="https://blog.reachr.com.br">Blog</a></li>
            <li><a href="/planos">Planos</a></li>
            <li><a href="/cases">Clientes e Cases</a></li>
            <li><a href="/funcionalidades">Funcionalidades</a></li>
            <li><a href="https://vagasti.reachr.com.br">Contratar profissionais de TI</a></li>
          </ul>
        </div>

        <div class="auth-footer-coluna">
          <h3>Para candidato</h3>
          <ul>
            <li><a href="https://blog.reachr.com.br/category/carreiras">Blog</a></li>
            <li><a href="/para-candidatos/avaliacao-comportamental">Avaliação Comportamental</a></li>
            <li><a href="/vagas">Todas as vagas</a></li>
            <li><a href="https://vagasti.reachr.com.br">Vagas para Profissionais de Tecnologia</a></li>
          </ul>
        </div>
      </div>

      <div class="auth-footer-base">
        <span>© {{ ano }} Reachr. Todos os direitos reservados.</span>
        <div>
          <a href="/politica-de-privacidade">Política de privacidade</a>
          <a href="/termos-de-uso">Termos de uso</a>
          <a href="/protecao-de-dados">LGPD</a>
        </div>
      </div>
    </div>
  </footer>
</div>
